import axios from './axiosConfig';

const API_URL = "/users/";

const getAllUsers = () => { // OK
    return axios.get(API_URL + 'all');
};

const registerUser = (data) => {
    return axios.post(API_URL + 'register', data);
}

const deleteUser = (userId) => { // OK
    return axios.delete(API_URL + userId);
};

const toggleAdmin = (userId) => { // OK
    return axios.post(API_URL + 'toggle-admin/' + userId);
};

const getUserGroup = () => { // OK
    return axios.get(API_URL + 'group');
};

const getUserId = () => {
    return axios.get(API_URL + 'userId');
}

const updatePassword = (currentPassword, newPassword, token) => {
    return axios.put(API_URL + 'update-password', { currentPassword, newPassword}, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

const makeAllUsersPlayers = async () => {
    return await axios.post(API_URL + 'make-all-players');
};

const getUserInfo = async () => {
    return await axios.get(API_URL + 'isAdmin');
}

const resetPassword = async (userId) => {
    return await axios.post(API_URL + 'reset-password/' + userId)
}

export default {
    getAllUsers,
    registerUser,
    deleteUser,
    toggleAdmin,
    getUserGroup,
    getUserId,
    updatePassword,
    makeAllUsersPlayers,
    getUserInfo,
    resetPassword
};